import styled from "@emotion/styled";
import { pxtorem } from "../../../assets/styles/theme";

export const HeaderStyled = styled('div')`
  padding: 0 20px;
  height: 60px;    
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;

  background: #14294e;
  background: -moz-linear-gradient(left, #14294e 0%, #08162e 100%);
  background: -webkit-linear-gradient(left, #14294e 0%, #08162e 100%);
  background: -o-linear-gradient(left, #14294e 0%, #08162e 100%);
  background: -ms-linear-gradient(left, #14294e 0%, #08162e 100%);
  background: linear-gradient(to right, #14294e 0%, #08162e 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#14294e', endColorstr='#08162e', GradientType=1 );
  
  .MuiButtonBase-root {
    border-radius: 100%;
    min-width: auto;
    width: 30px;
    height: 30px;
    font-size:  ${pxtorem(16)};
    text-transform: uppercase;
  }
`;